import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IProtocolReference } from "../shared/interfaces";

const controller = 'ProtocolReferences';



const getRiferimentiProtocollo = (aooId: number, uorId: number | undefined, protocolId: number, cancelToken?: CancelToken): Promise<IProtocolReference[]> => {
    return axiosInstance.get(`${controller}/${aooId}/GetRiferimentiProtocollo/${protocolId}`, { params: { uorId: uorId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getSeguitiProtocollo = (aooId: number, uorId: number | undefined, protocolId: number, cancelToken?: CancelToken): Promise<IProtocolReference[]> => {
    return axiosInstance.get(`${controller}/${aooId}/GetSeguitiProtocollo/${protocolId}`, { params: { uorId: uorId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const createReference = (aooId: number, uorId: number, protocolId: number, referenceId: number,cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/${uorId}/CreateReference`, null, { params: { protocolId, referenceId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const deleteReference = (aooId: number, uorId: number, protocolId: number, referenceId: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.delete(`${controller}/${aooId}/${uorId}/DeleteReference`, { params: { protocolId, referenceId }, cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


export default {
    getRiferimentiProtocollo,
    getSeguitiProtocollo,
    createReference,
    deleteReference
}